import type { FC } from "react";
import { FileIcon } from "lucide-react";

type GenericViewerProps = {
  fileName: string;
  mime: string;
};

export const GenericViewer: FC<GenericViewerProps> = ({ fileName, mime }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 p-4">
      <FileIcon className="w-24 h-24 text-zinc-400" />
      <p className="text-lg font-medium text-zinc-700 dark:text-zinc-300">{fileName}</p>
      <p className="text-sm text-zinc-500">{mime}</p>
      <p className="text-sm text-zinc-400 italic">No preview available</p>
    </div>
  );
};
